import s from './FormRequestDetails.module.scss';

const NoFormResponse: React.FC = () => (
  <span className={s['no-response']}>We are generating your form results... You might need to refresh the page to see them.</span>
);

export default NoFormResponse;